import type { TransferSource } from '@/types/product-actions'

// Order = option order in the "Manba" filter select.
export const TRANSFER_SOURCES = [
  'manual',
  'order',
  'mml_frozen_return',
  'mml_restock',
] as const satisfies readonly TransferSource[]

// Full literal class strings so Tailwind's content scan picks them up.
export const TRANSFER_SOURCE_DOT_CLASS: Record<TransferSource, string> = {
  manual: 'bg-slate-400 dark:bg-slate-500',
  order: 'bg-amber-500 dark:bg-amber-400',
  mml_frozen_return: 'bg-cyan-500 dark:bg-cyan-400',
  mml_restock: 'bg-violet-500 dark:bg-violet-400',
}

export const isTransferSource = (value: unknown): value is TransferSource =>
  typeof value === 'string' &&
  (TRANSFER_SOURCES as readonly string[]).includes(value)

export const normalizeTransferSource = (
  value: string | null | undefined
): TransferSource | null => (isTransferSource(value) ? value : null)

export const getTransferSourceLabelKey = (source: TransferSource): string =>
  `product_transfer.source_options.${source}`

// True when the cached list query was fetched with a known `source` filter.
export const isSourceFilteredTransferListKey = (
  queryKey: readonly unknown[]
): boolean => {
  const params = queryKey[1]
  if (typeof params !== 'object' || params === null) return false
  return isTransferSource((params as { source?: unknown }).source)
}
